export default function PageSkeleton() {
  return (
    <div className='bg-[#F8FAFC] pt-32 min-h-screen px-6'>
      <div className='max-w-4xl mx-auto space-y-4'>
        <div className='h-40 animate-pulse rounded-3xl bg-slate-200' />
        <div className='h-64 animate-pulse rounded-3xl bg-slate-200' />
      </div>
    </div>
  );
}
